jQuery($ => {
  // Footer
	// Keep footer at bottom
	const windowH = $(window).outerHeight(true);
	const headerH = $('header').outerHeight(true);
	const footerH = $('footer').outerHeight(true);
	const main = $('main');

	main.css({'min-height': windowH - (headerH + footerH)});
});